// Anasayfa (Roadmap v9) markup'ındaki metinler: kaynak (Türkçe) metin -> i18n anahtarı (landingPage.roadmap.<anahtar>).
// Metin karşılaştırması boşluklar normalize edilerek yapılır; listede olmayan metinler (özel isimler, kod örnekleri) çevrilmez.
export const LANDING_ROADMAP_TEXT_KEYS: Record<string, string> = {
  'İş İlanları': 'navJobs',
  İşverenler: 'navEmployers',
  Fiyatlandırma: 'navPricing',
  Platform: 'navPlatform',
  'PEOPLY PLATFORM': 'menuEyebrow',
  'İşe alım ve çalışan yönetimi, tek platformda.': 'menuTitle',
  'Doğru adayı bulun, ekip süreçlerini yönetin ve tüm insan operasyonunuzu tek yerde büyütün.': 'menuDescription',
  'Platformu keşfet': 'menuExplore',
  'İŞE ALIM': 'menuRecruitingTitle',
  'İlan Yönetimi': 'menuJobManagement',
  'İş ilanlarını oluştur, yayınla ve yönet.': 'menuJobManagementDesc',
  'Aday Yönetimi': 'menuCandidateManagement',
  'Başvuruları tek yerde görüntüle ve adayları yönet.': 'menuCandidateManagementDesc',
  'Aday Değerlendirme': 'menuCandidateEvaluation',
  'Adayları karşılaştır ve doğru adayı belirle.': 'menuCandidateEvaluationDesc',
  'İşe Alım Süreci': 'menuHiringProcess',
  'Adaydan işe alıma kadar tüm süreci yönet.': 'menuHiringProcessDesc',
  'İK YÖNETİMİ': 'menuHrTitle',
  'Çalışan Yönetimi': 'menuEmployeeManagement',
  'Çalışan bilgilerini ve süreçlerini merkezi yönetin.': 'menuEmployeeManagementDesc',
  Performans: 'menuPerformance',
  'Hedef ve performans süreçlerini takip edin.': 'menuPerformanceDesc',
  'İzin Yönetimi': 'menuLeaveManagement',
  'İzin taleplerini ve süreçlerini kolayca yönetin.': 'menuLeaveManagementDesc',
  'Raporlama & Analitik': 'menuReporting',
  'İK ve işe alım verilerini analiz edin.': 'menuReportingDesc',
  'Giriş Yap': 'navLogin',
  'Kayıt Ol': 'navSignup',
  'Adaydan çalışana,': 'heroTitle1',
  'tüm yolculuk': 'heroTitle2',
  'tek platformda.': 'heroTitle3',
  'İlan açın, adayı değerlendirin, işe alın ve ekibinizi yönetin. Hepsi aynı hikâyenin parçası.': 'heroDescription',
  'Demo Talep Et ›': 'heroDemoCta',
  'Kariyer & ilanlar': 'heroCheckCareers',
  'Sınav & değerlendirme': 'heroCheckExams',
  'İşe alım & İK yönetimi': 'heroCheckHr',
  'İK’nın tüm resmi, tek yerde.': 'heroNote',
  çalışan: 'orbEmployees',
  'YENİ BAŞVURU': 'orbNewApplication',
  '01 · İŞE ALIM': 'orbStep1',
  'Açık pozisyonu yönet': 'orbStep1Desc',
  'açık pozisyon': 'orbOpenPositions',
  '02 · DEĞERLENDİRME': 'orbStep2',
  'Adayı değerlendir': 'orbStep2Desc',
  MÜLAKAT: 'orbInterview',
  onboarding: 'orbOnboarding',
  'ÇALIŞAN · Aktif': 'orbEmployeeActive',
  '03 · ONBOARDING': 'orbStep3',
  'Yeni çalışanı başlat': 'orbStep3Desc',
  'İzin talebi': 'orbLeaveRequest',
  'Elif · 3 gün': 'orbLeaveDays',
  Bekliyor: 'orbPending',
  'Onaylandı ✓': 'orbApproved',
  'İK onayladı': 'orbHrApproved',
  EKİP: 'orbTeam',
  '24 çalışan': 'orbTeamCount',
  '04 · ÇALIŞAN YÖNETİMİ': 'orbStep4',
  'Ekibini yönet': 'orbStep4Desc',
  'performans değerlendirmesi': 'orbPerformanceReviews',
  '05 · GELİŞİM': 'orbStep5',
  'Performansı takip et': 'orbStep5Desc',
  'Her süreç': 'orbNote1Line1',
  'tek yerde.': 'orbNote1Line2',
  'Doğru karar,': 'orbNote2Line1',
  'doğru zamanda.': 'orbNote2Line2',
  'Yolculuk burada': 'journeyNoteLine1',
  'devam ediyor': 'journeyNoteLine2',
  'Doğru yetenekle doğru fırsatı buluştur.': 'matchTitle',
  'Aday profili ile pozisyon karşılıklı eşleşir. Uyum oranı gerekçesiyle birlikte görünür.': 'matchDescription',
  'CV saniyeler içinde profile dönüşür': 'matchCheckCv',
  'Aday → pozisyon, pozisyon → aday': 'matchCheckBothWays',
  'Başvuru tek tıkla gönderilir': 'matchCheckOneClick',
  'uyum · Senior Frontend': 'matchFitRole',
  'aday ↔ pozisyon': 'matchBothWays',
  'Uyum, gerekçesiyle.': 'matchNote',
  'Ürün Yöneticisi': 'cvRole',
  'Yeni fırsatlara açık': 'cvOpenToWork',
  'PROFİL GÜCÜ': 'cvProfileStrength',
  'İstanbul, Türkiye': 'cvLocation',
  Profil: 'cvProfile',
  'Özet ekleniyor': 'cvAddingSummary',
  Yetenekler: 'cvSkills',
  'Ürün Stratejisi': 'cvSkillProductStrategy',
  'Kullanıcı Araştırması': 'cvSkillUserResearch',
  'Veri Analizi': 'cvSkillDataAnalysis',
  'Proje Yönetimi': 'cvSkillProjectManagement',
  'Ekip Liderliği': 'cvSkillTeamLeadership',
  'Yetenekler ekleniyor': 'cvAddingSkills',
  Diller: 'cvLanguages',
  Türkçe: 'cvLanguageTurkish',
  'Ana dil': 'cvNativeLanguage',
  İngilizce: 'cvLanguageEnglish',
  'İleri seviye': 'cvAdvanced',
  '+12 global ilan açılır': 'cvGlobalJobsNote',
  'Diller ekleniyor': 'cvAddingLanguages',
  'İlgi Alanları': 'cvInterests',
  Teknoloji: 'cvInterestTechnology',
  Seyahat: 'cvInterestTravel',
  Fotoğraf: 'cvInterestPhotography',
  Doğa: 'cvInterestNature',
  Kitap: 'cvInterestBooks',
  'İlgi alanları ekleniyor': 'cvAddingInterests',
  Deneyim: 'cvExperience',
  'ölçülebilir etki ↓': 'cvMeasurableImpact',
  '2022 – Günümüz': 'cvPresent',
  'Deneyim ekleniyor': 'cvAddingExperience',
  'Kıdemli Ürün Uzmanı': 'cvSeniorProductSpecialist',
  'Ürün Uzmanı': 'cvProductSpecialist',
  Eğitim: 'cvEducation',
  'Endüstri Mühendisliği': 'cvIndustrialEngineering',
  'Eğitim ekleniyor': 'cvAddingEducation',
  Sertifikalar: 'cvCertificates',
  'Ürün Yönetimi Sertifikası · Google': 'cvCertProductManagement',
  'Kullanıcı Deneyimi (UX) · Coursera': 'cvCertUx',
  'Sertifikalar ekleniyor': 'cvAddingCertificates',
  'Güçlü profil': 'cvStrongProfile',
  'Bu profil 46 ilanla eşleşiyor →': 'cvMatchesJobs',
  'Yükle, gerisini bırak.': 'cvStep1Title',
  "PDF'teki özgeçmişin saniyeler içinde yapılandırılmış bir profile dönüşür: deneyim, eğitim ve yetenekler. Sen yalnızca kontrol edersin.":
    'cvStep1Description',
  'Kenarda bir koç.': 'cvStep2Title',
  'Peoply güçlü yanlarının altını çizer, eksiklerini söyler. Hangi yeteneğin kaç ilanın kapısını açacağını tek tek gösterir.':
    'cvStep2Description',
  'Uyan fırsatlar, doğru adaylar.': 'cvStep3Title',
  'Her ilanda bir uyum oranı ve gerekçesi. Tek tıkla başvurur, sürecini değerlendirme, mülakat ve teklif adımlarıyla izlersin.':
    'cvStep3Description',
  'İlan kalabalığı değil, doğru eşleşme.': 'listingTitle',
  'Adaylar için doğru fırsatı, firmalar için doğru yeteneği yalnızca yüzdeyle değil, net gerekçelerle gösteriyoruz.':
    'listingDescription',
  'Her ilanda uyum oranı ve gerekçesi': 'listingCheckFit',
  'Tek tıkla başvuru': 'listingCheckOneClick',
  'Değerlendirme, mülakat ve teklif adımlarıyla izle': 'listingCheckTrack',
  'Doğru ilan, doğru an.': 'listingNote',
  'İlanını yayınla. Doğru yeteneği bul.': 'employerTitle',
  'Pozisyonunu birkaç dakikada oluştur, gereksinimlerini netleştir ve sana uyan adayları ilk başvurudan önce gör.':
    'employerDescription',
  'İlanı oluştur': 'employerCheckCreate',
  'Adayları keşfet': 'employerCheckDiscover',
  'Ekibini kur': 'employerCheckTeam',
  'İlan yayınlamaya başla →': 'employerCta',
  'Daha az gürültü,': 'employerNoteLine1',
  'daha doğru buluşma.': 'employerNoteLine2',
  Yetkinlik: 'examTitle1',
  Sınavı: 'examTitle2',
  'Elif Yılmaz · Aday': 'examCandidate',
  İLERLEME: 'examProgress',
  'İK tarafından atandı': 'examAssignedByHr',
  '3 soru': 'examQuestionCount',
  '20 dk': 'examDuration',
  'Otomatik kayıt': 'examAutoSave',
  Sorular: 'examQuestions',
  'Soru 01': 'examQuestion1',
  'kaydedildi ✓': 'examSaved',
  'React’te bir bileşenin gereksiz yere yeniden render olmasını hangisi engeller?': 'examQuestion1Text',
  'Soru 02': 'examQuestion2',
  'Bir öğeyi hem yatay hem dikey ortalamanın en kısa yolu hangisi?': 'examQuestion2Text',
  'Soru 03': 'examQuestion3',
  'TypeScript’te bir nesnenin tüm alanlarını opsiyonel yapan yardımcı tip?': 'examQuestion3Text',
  'Cevaplar otomatik kaydediliyor': 'examAnswersSaving',
  'Sınav tamamlandı': 'examCompleted',
  'Sonuç İK ekranına iletildi': 'examResultSent',
  'Güçlü sonuç!': 'examStrongResult',
  'Doğru adaya, doğru sınav.': 'examStep1Title',
  'İK, başvuranlar arasından değerlendirmek istediği adayı seçer ve ona sınav atar. Aday daveti alır; süre, soru sayısı ve kurallar baştan net.':
    'examStep1Description',
  'Her cevap kayıt altında.': 'examStep2Title',
  'Aday soruları kendi hızında yanıtlar. Verdiği her cevap ve her soruda harcadığı süre anında kayda geçer; bağlantı koparsa sınav kaldığı yerden devam eder.':
    'examStep2Description',
  'Sonuç, değerlendirmeye düşer.': 'examStep3Title',
  'Sınav biter bitmez puan ve yetkinlik kırılımı İK ekranına gelir. Doğru aday, ilk bakışta öne çıkar.':
    'examStep3Description',
  'İK operasyonun için ihtiyacın olan her modül.': 'modulesTitle',
  'Çalışan bilgilerinden izin ve masrafa, envanterden performansa kadar tüm süreçleri tek platformda yönet; ihtiyacın olan modülle başla, birlikte büyü.':
    'modulesDescription',
  'Çalışan yönetimi': 'modEmployeeTitle',
  'Tüm çalışan bilgilerini, özlük dosyalarını ve organizasyon yapını tek yerde topla; ekibinin güncel resmini her an gör.':
    'modEmployeeDescription',
  'Keşfet →': 'modEmployeeCta',
  '128 çalışan': 'modEmployeeCount',
  'Ekibin güncel resmi.': 'modEmployeeNote',
  'İzin, mesai ve masraf yönetimi': 'modLeaveTitle',
  'İzin, fazla mesai ve masraf taleplerini tek akışta al, onayla ve takip et. Bakiyeler ve kayıtlar kendiliğinden güncellensin.':
    'modLeaveDescription',
  'Nasıl çalışır →': 'modLeaveCta',
  'izin · mesai · masraf': 'modLeaveTags',
  '3 talep onayda': 'modLeavePending',
  'Envanter yönetimi': 'modInventoryTitle',
  'Laptop, telefon ve ekipmanları çalışanlara zimmetle, kimde ne olduğunu anında gör; iade ve işten ayrılış süreçlerini kaçırma.':
    'modInventoryDescription',
  'Göz at →': 'modInventoryCta',
  '312 varlık': 'modInventoryCount',
  'zimmet · iade': 'modInventoryTags',
  'Kimde ne var?': 'modInventoryNote',
  'Aday ve pozisyon yönetimi': 'modCandidateTitle',
  'Pozisyonlarını aç, başvuruları aşama aşama ilerlet ve doğru adayı ekibinle birlikte, tek panelden işe al.':
    'modCandidateDescription',
  'Süreci gör →': 'modCandidateCta',
  'başvuru → mülakat → teklif': 'modCandidateTags',
  '12 başvuru': 'modCandidateCount',
  'Duyuru modülü': 'modAnnouncementTitle',
  'Şirket haberlerini doğru kişilere ulaştır; kimin okuduğunu takip et ve önemli mesajların ekipte kaybolmasını önle.':
    'modAnnouncementDescription',
  'Hemen başla →': 'modAnnouncementCta',
  'tüm şirket · İstanbul': 'modAnnouncementTags',
  'Kim okudu, takipte.': 'modAnnouncementNote',
  'Hedef ve performans yönetimi': 'modGoalsTitle',
  'Şirket, ekip ve bireysel hedefleri hizala; ilerlemeyi canlı takip et ve performans değerlendirmelerini net verilerle yürüt.':
    'modGoalsDescription',
  'Detaylı incele →': 'modGoalsCta',
  'Q4 · %72 tamamlandı': 'modGoalsProgress',
  'Hedefler hizalı.': 'modGoalsNote',
};
